import React, { useContext } from "react";
import {
  Row,
  IconWrapper,
  IconBox,
  TextWrapper,
  Text,
} from "../styled/Tooltip.styled";
import { formatSupplyLevel, SupplyType } from "../../constants/WebMap";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";

export default function TooltipInternal({
  rsrpValue,
  uploadValue,
  downloadValue,
  rsrpLevel,
  uploadLevel,
  downloadLevel,
  supplyType,
}) {
  const { supplyStrengthLevels = {} } = useContext(WebMapContext);
  return (
    <div>
      <Row>
        <div
          style={{ display: "flex", alignItems: "center", margin: "1px 0px" }}
        >
          <IconWrapper>
            <img src={"/assets/signal.png"} alt="logo1" width="13" />
          </IconWrapper>
          <Text isBold={supplyType === SupplyType.RSRP ? true : false}>
            Signal Strength
          </Text>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "80px",
          }}
        >
          <IconBox
            backgroundColor={`${
              supplyStrengthLevels[
                formatSupplyLevel(rsrpLevel)
              ]
            } 0% 0% no-repeat padding-box`}
          />
          <TextWrapper isBold={supplyType === SupplyType.RSRP ? true : false}>
            {rsrpValue
              ? `${rsrpValue} dBm`
              : rsrpLevel ? rsrpLevel : "No Data"}
          </TextWrapper>
        </div>
      </Row>
      <Row>
        <div
          style={{ display: "flex", alignItems: "center", margin: "1px 0px" }}
        >
          <IconWrapper>
            <img src={"/assets/download.png"} alt="logo1" width="13" />
          </IconWrapper>
          <Text isBold={supplyType === SupplyType.DOWNLOAD ? true : false}>
            Download
          </Text>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "80px",
          }}
        >
          <IconBox
            backgroundColor={`${
              supplyStrengthLevels[
                formatSupplyLevel(downloadValue ? downloadLevel : null)
              ]
            } 0% 0% no-repeat padding-box`}
          />
          <TextWrapper
            isBold={supplyType === SupplyType.DOWNLOAD ? true : false}
          >
            {downloadValue ? `${downloadValue} Mbps` : "No Data"}
          </TextWrapper>
        </div>
      </Row>
      <Row>
        <div
          style={{ display: "flex", alignItems: "center", margin: "1px 0px" }}
        >
          <IconWrapper>
            <img src={"/assets/upload.png"} alt="logo1" width="13" />
          </IconWrapper>
          <Text isBold={supplyType === SupplyType.UPLOAD ? true : false}>
            Upload
          </Text>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "80px",
          }}
        >
          <IconBox
            backgroundColor={`${
              supplyStrengthLevels[
                formatSupplyLevel(uploadValue ? uploadLevel : null)
              ]
            } 0% 0% no-repeat padding-box`}
          />
          <TextWrapper isBold={supplyType === SupplyType.UPLOAD ? true : false}>
            {uploadValue ? `${uploadValue} Mbps` : "No Data"}
          </TextWrapper>
        </div>
      </Row>
    </div>
  );
}
